
import { useDispatch, useSelector } from 'umi';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/storeRankExtend';
export default function useFilterExtend(props: any) {

  const dispatch = useDispatch();
  const { isOperate, topchartFilterExtendCommon, isOperateDetail, isOperateRegion, detailFilterExtendCommon } = useSelector(state => {
    // @ts-ignore
    const { isOperate, topchartFilterExtendCommon, isOperateDetail, isOperateRegion, detailFilterExtendCommon } = state[FILTER_EXTEND_NAMESPACE];
    return {
      isOperate, topchartFilterExtendCommon, isOperateDetail, isOperateRegion, detailFilterExtendCommon
    }
  });

  /**修改榜单继承：榜单继承同时继承详情 */
  const setTopchartFilterExtendFun = (value: any) => {
    setFilterExtendFun(value, topchartFilterExtendCommon, `${FILTER_EXTEND_NAMESPACE}/saveTopchartFilterExtendCommon`)
    dispatch({
      type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperate`,
      payload: true
    })
  }

  //设置详情页继承
  const setDetailFilterExtendFun = (value: any) => {
    setFilterExtendFun(value, detailFilterExtendCommon, `${FILTER_EXTEND_NAMESPACE}/saveDetailFilterExtendCommon`)
    dispatch({
      type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperateDetail`,
      payload: true
    })
  }

  const setFilterExtendFun = (value: any, filterExtendCommon: any, dispatchType: string) => {
    /**国家筛选器：级联筛选器与下拉筛选器数据互通，在页面取交集 */
    const newVal = value || {};

    dispatch({
      type: dispatchType,
      payload: isOperate ? {
        ...filterExtendCommon || {},
        ...newVal
      } : newVal
    })
  }

  /**修改榜单继承：清除榜单继承同时清除详情详情 */
  const resetTopchartFilterExtendFun = (value: any,) => {
    // resetFilterExtendFun(value, dispatchType)
    resetFilterExtendFun(value, `${FILTER_EXTEND_NAMESPACE}/saveTopchartFilterExtendCommon`)
    dispatch({
      type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperate`,
      payload: false
    })
    dispatch({
      type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperateRegion`,
      payload: false
    })
  }

  //清除详情页继承
  const resetDetailFilterExtendFun = (value: any) => {
    resetFilterExtendFun(value, `${FILTER_EXTEND_NAMESPACE}/saveDetailFilterExtendCommon`)
    dispatch({
      type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperateDetail`,
      payload: false
    })
    dispatch({
      type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperateRegion`,
      payload: false
    })
  }

  const resetFilterExtendFun = (value: any, dispatchType: string) => {
    dispatch({
      type: dispatchType,
      payload: null
    })
  }

  const modelValueName = () => {
    return {
      filterExtend: isOperate ? topchartFilterExtendCommon : null,
      detailFilterExtend: isOperateDetail ? detailFilterExtendCommon : null,
      setFilterExtend: (value: any) => { setTopchartFilterExtendFun(value); setDetailFilterExtendFun(value) },
      resetFilterExtend: (value?: any) => { resetTopchartFilterExtendFun(value), resetDetailFilterExtendFun(value,) },
      setDetailFilterExtend: (value: any) => setDetailFilterExtendFun(value,),
      resetDetailFilterExtend: (value?: any) => resetDetailFilterExtendFun(value,)
    }
  }
  const {
    filterExtend,
    detailFilterExtend,
    setFilterExtend,
    resetFilterExtend,
    setDetailFilterExtend,
    resetDetailFilterExtend,
  } = modelValueName();

  return {
    isOperate,
    //榜单页继承
    filterExtend,
    setFilterExtend,
    resetFilterExtend,
    //详情页的继承
    isOperateDetail,
    isOperateRegion,
    detailFilterExtend,
    setDetailFilterExtend,
    resetDetailFilterExtend
  }

}
